import { memo, useCallback } from "react";

import { Text } from "@react/components/Text";
import { Toggle } from "@react/components/Toggle";
import { type SizeGuideDimensionsUnit } from "@tablescape/state";
import { tw } from "classnames";

const styles = {
  toggle: tw("flex", "items-center", "mt-8", "mb-6"),
  leftLabel: tw("mr-1"),
  rightLabel: tw("ml-1"),
};

type Props = {
  onToggle: (unitSelected: SizeGuideDimensionsUnit) => void;
  toggleAlt?: string;
  unitSelected: SizeGuideDimensionsUnit;
};

const UnitToggleBase = ({ onToggle, toggleAlt, unitSelected }: Props) => {
  const handleChange = useCallback(
    (value: boolean) => {
      onToggle(value ? "cm" : "in");
    },
    [onToggle]
  );

  return (
    <div className={styles.toggle}>
      <Text as="title1" className={styles.leftLabel} size={{ sm: "md" }}>
        in
      </Text>
      <Toggle
        alt={toggleAlt}
        initialValue={unitSelected === "cm"}
        onChange={handleChange}
      />
      <Text as="title1" className={styles.rightLabel} size={{ sm: "md" }}>
        cm
      </Text>
    </div>
  );
};

export const UnitToggle = memo(UnitToggleBase);
